var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f6d6e",
    d: "M.754 16c.067 0 .134-.008.202-.028l4.864-1.366c.242-.068.463-.198.638-.377l8.877-8.877c.427-.428.665-.994.665-1.597 0-.602-.234-1.168-.662-1.596L13.845.666C13.417.238 12.851 0 12.245 0c-.602 0-1.169.234-1.596.662L1.772 9.543c-.179.178-.305.396-.377.638L.03 15.045c-.076.262 0 .543.194.737.138.143.333.218.53.218zm5.177-3.145l-2.78-2.781 6.765-6.766 2.78 2.78-6.765 6.767zm6.314-11.508c.241 0 .471.095.646.265l1.493 1.494c.17.17.265.4.265.645 0 .246-.095.472-.265.646l-.737.737-2.78-2.78.736-.738c.17-.174.4-.27.642-.27zM2.477 11.31l2.214 2.214-3.082.868.868-3.082z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c788d936951e712fe8e5389a74f0763f.svg";
export { ForwardRef as ReactComponent };